import { parseQuery } from '@calendly/http-tools'
import { Segment as BaseSegment } from '@calendly/segment'

function addExtensionProperties(properties) {
  const allParams = parseQuery(window.location.search)

  if (
    allParams.platform
    && allParams.version
    && allParams.source) {
    const props = {
      ...properties,
      platform: allParams.platform,
      version: allParams.version,
      source: allParams.source
    }
    if (allParams.sidebar_view) {
      props.sidebar_view = allParams.sidebar_view
    }
    return props
  }
  return properties
}

export const Segment = {
  identify: BaseSegment.identify,
  trackNamedPage: BaseSegment.trackNamedPage,
  isTrackableAttributeValue: BaseSegment.isTrackableAttributeValue,
  trackLink($element, event, properties = {}) {
    BaseSegment.trackLink($element, event, addExtensionProperties(properties))
  },
  trackForm($element, event, properties = {}) {
    BaseSegment.trackForm($element, event, addExtensionProperties(properties))
  },
  track(event, properties = {}) {
    BaseSegment.track(event, addExtensionProperties(properties))
  },
  trackClick(element, event, properties = {}) {
    BaseSegment.trackClick(element, event, addExtensionProperties(properties))
  },
}
